module.exports = __webpack_public_path__ + "static/media/hand.25c125b5.svg";